import i18next from 'i18next';

import es from './es.json';

const resources = {
  es: { allTranslations: es }
};

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'es',
  resources,
  ns: ['allTranslations']
});

export default i18next;
